/* global axios */
import ApiClient from './ApiClient';

class BroadcastsAPI extends ApiClient {
  constructor() {
    super('broadcast_campaigns', { accountScoped: true });
  }

  startCampaign(id) {
    return axios.post(`${this.url}/${id}/start`);
  }

  pauseCampaign(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resumeCampaign(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  getRecipients(campaignId, page = 1) {
    return axios.get(`${this.url}/${campaignId}/broadcast_recipients?page=${page}`);
  }

  createRecipient(campaignId, payload) {
    return axios.post(`${this.url}/${campaignId}/broadcast_recipients`, payload);
  }

  deleteRecipient(campaignId, recipientId) {
    return axios.delete(`${this.url}/${campaignId}/broadcast_recipients/${recipientId}`);
  }

  importRecipients(campaignId, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${this.url}/${campaignId}/broadcast_recipients/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  addAllContacts(campaignId) {
    return axios.post(`${this.url}/${campaignId}/broadcast_recipients/add_all_contacts`);
  }
}

export default new BroadcastsAPI();
